/** 2×3 toroidal grid — swipe wraps like a cube unfolded (6 faces). */
export const CUBE_GRID = [
  [
    { path: "/help", label: "Ayuda" },
    { path: "/dashboard", label: "Panel" },
    { path: "/atlas", label: "Atlas" },
  ],
  [
    { path: "/", label: "Hoy" },
    { path: "/drawers", label: "Cajones" },
    { path: "/library", label: "Biblioteca" },
  ],
];

const ROWS = CUBE_GRID.length;
const COLS = CUBE_GRID[0].length;

const STORAGE_KEY = "trufapp_cube_nav";

export function isCubeNavEnabled(settings = {}) {
  if (typeof settings.cubeNavigationEnabled === "boolean") {
    return settings.cubeNavigationEnabled;
  }
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function persistCubeNavLocal(enabled) {
  try {
    if (enabled) localStorage.setItem(STORAGE_KEY, "1");
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Routes where cube swipe is active (main palace views). */
export function isCubeNavRoute(pathname) {
  if (!pathname) return false;
  if (pathname.startsWith("/a/") || pathname.startsWith("/notas/")) return false;
  if (pathname.startsWith("/editor")) return false;
  return pathToCell(pathname) != null;
}

function normalizePath(pathname) {
  if (!pathname || pathname === "/hoy") return "/";
  return pathname;
}

export function pathToCell(pathname) {
  const path = normalizePath(pathname);
  for (let row = 0; row < ROWS; row += 1) {
    for (let col = 0; col < COLS; col += 1) {
      const cell = CUBE_GRID[row][col];
      if (cell.path === "/") {
        if (path === "/") return { row, col, ...cell };
        continue;
      }
      if (path === cell.path || path.startsWith(`${cell.path}/`)) {
        return { row, col, ...cell };
      }
    }
  }
  return null;
}

export function cellToPath(row, col) {
  const r = ((row % ROWS) + ROWS) % ROWS;
  const c = ((col % COLS) + COLS) % COLS;
  return CUBE_GRID[r][c];
}

export function neighborCell(row, col, direction) {
  let nr = row;
  let nc = col;
  if (direction === "left") nc -= 1;
  else if (direction === "right") nc += 1;
  else if (direction === "up") nr -= 1;
  else if (direction === "down") nr += 1;
  else return null;
  if (nc < 0) nc = COLS - 1;
  if (nc >= COLS) nc = 0;
  if (nr < 0) nr = ROWS - 1;
  if (nr >= ROWS) nr = 0;
  return { ...cellToPath(nr, nc), row: nr, col: nc };
}

export function directionFromDelta(dx, dy, { verticalFromEdge = false } = {}) {
  const ax = Math.abs(dx);
  const ay = Math.abs(dy);
  if (ax < 48 && ay < 48) return null;
  if (ax > ay * 1.25) {
    return dx > 0 ? "right" : "left";
  }
  if (ay > ax * 1.25) {
    if (!verticalFromEdge) return null;
    return dy > 0 ? "down" : "up";
  }
  return null;
}
